import { ProgressIcon } from 'assests/GmsIcons'
import React from 'react'

type ProgressModalProps = {
    action: string
}

const ProgressModal = ({ action }: ProgressModalProps) => {
    return (
        <div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-py-10">
            <div className="tw-animate-spin tw-mb-4">
                <ProgressIcon />
            </div>
            <p className="tw-text-lg tw-font-medium tw-text-accent">{action} in progress...</p>
        </div>
    )
}

export default ProgressModal